__turbopack_context__.v({
  "bleed": "Container-module__V7bQUq__bleed",
  "container": "Container-module__V7bQUq__container",
  "default": "Container-module__V7bQUq__default",
  "full": "Container-module__V7bQUq__full",
  "narrow": "Container-module__V7bQUq__narrow",
});
